
    <div
      #container
      class="dropdown-container mdl-shadow--8dp"
      [class.visible]="show">
      <ng-content></ng-content>
    </div>
  